import { SocietyCorporateId } from 'types/Society';
import { isPlatformASG } from 'utils/showDetails';
import { loginsByCorporateId } from '../constants/loginsByCorporateId';

export const getLoginByCorporateId = () => {
  const corporateId = isPlatformASG
    ? SocietyCorporateId.ASG
    : (process.env.REACT_APP_UI_CORPORATE_ID as SocietyCorporateId) ||
      SocietyCorporateId.DEFAULT;

  return loginsByCorporateId[corporateId];
};
